import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';



export default function About() {
    return (
        <>
            <Helmet>
                 <title>About Railing World | Railing Manufacturer in Rajkot</title>
                 <meta name="description" content="Learn about Railing World – leading supplier of balcony, glass, and steel railings in Rajkot, India." />
                 <link rel="canonical" href="https://www.railingworld.in/about" />
            </Helmet>

            <div className="page-title light-background">
                <div className="container d-lg-flex justify-content-between align-items-center">
                    {/* <h1 className="mb-2 mb-lg-0">Product Category</h1> */}
                    <nav className="breadcrumbs">
                        <ol>
                            <li><Link to="/">Home</Link></li>
                            <li className="current">About</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="py-3">
                <section className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <h3 className="display-4">About <span className='first-word'>Railing World</span></h3>
                                {/* <p className="lead">Aluminium & Stainless steel glass railing system</p> */}
                                <p>
                                The name of our long-standing enterprise hints of our area of expertise. We RAILING WORLD, are a railing manufacturer and supplier, widely accepted for introducing matchless quality and designer array of railing, in Aluminum, stainless steel and glass.
We are a perfectionist in introducing uniquely designed Aluminum glass railing, Modular railing, Balcony railing, stainless steel balcony railing, Glass stair railing, Glass deck railing and other railing. Each piece in our portfolio excellently showcases creativity of our designers, who put their imagination and strength in designing railing.

                            </p>
                            <h3>Our Ethics:</h3>
                                <p>Our exclusive range of Aluminum steel railing products supplies meets the demands of several users like Architects, Engineers, Civil contractors & Direct users owing to their excellent technical & physical properties.</p>
                            <div className="col-md-12 text-center">
                            <button className="btn-download"
                                onClick={() => {
                                    const link = document.createElement('a');
                                    link.href = '/Catalog.pdf';
                                    link.download = 'Railing World Catalog.pdf';
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }}
                            >
                            Download Catalog
                            </button>
                      </div>
                        </div>
                        
                            <div className="col-md-6 text-center">
                                <img
                                    src="/images/About-page-image.webp"
                                    alt="About Company"
                                    className="img-fluid rounded shadow-sm"
                                />
                            </div>
                        </div>
                </section>

                <section id="stats" className="stats section light-background">
                <div className="container aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-4 custom-mobile-count-cols">
                    <div className="col-lg-3 col-md-6">
                        <div className="stats-item text-center w-100 h-100">
                        <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="0" className="purecounter">12</span>
                        <p>Year of Experience</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="stats-item text-center w-100 h-100">
                        <span data-purecounter-start="0" data-purecounter-end="521" data-purecounter-duration="0" className="purecounter">96</span>
                        <p>Project Completed</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="stats-item text-center w-100 h-100">
                        <span data-purecounter-start="0" data-purecounter-end="1453" data-purecounter-duration="0" className="purecounter">750+</span>
                        <p>Product</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="stats-item text-center w-100 h-100">
                        <span data-purecounter-start="0" data-purecounter-end="32" data-purecounter-duration="0" className="purecounter">32</span>
                        <p>Project Completed</p>
                        </div>
                    </div>
                    </div>

                </div>
                </section>
                <div className="container py-5 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                    <div className="service-item d-flex position-relative h-100">
                <i className="bi bi-briefcase icon flex-shrink-0"></i>
                <div>
                    <h4 className="title"><a href="/" className="stretched-link">Railing World Steel & Clients:</a></h4>
                    <p className="description">Our enormous success in the domestic market is solely based on our reliable, responsible & quality conscious clients. throughout the year we have been able to maintain & develop a strong relationship with our clients. The cordial relationship with our clients allow us to supply premium range of precision steel railing as well as fittings. We ensure the quality of our sourced products meet the international standard for quality. further, we endeavor to maintain long term relationship with our widespread clients.</p>
                </div>
                    </div>
                </div>

                <div className="container py-5 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                    <div className="container section-title aos-init aos-animate" data-aos="fade-up">
        <p className='text-center manufact-field'>Manufacture By</p>
      </div>
            <div className="d-block position-relative h-100">
            <div className="text-center mx-auto">
                    <h1 className="fw-bold title text-center text-black metro-text">METRO STEEL</h1>
                        </div>
            <div className="text-center mx-auto">
                    <img
                         src="/images/mki.webp"
                        alt="Make In India"
                        className="img-fluid rounded shadow-sm me-3"
                        style={{ width: '130px', height: 'auto' }}
                            />
                            <img
                         src="/images/sba.webp"
                        alt="Make In India"
                        className="me-2 img-fluid rounded shadow-sm"
                        style={{ width: '130px', height: 'auto' }}
                    />
            </div>
        </div>
    </div>


            </div>
        </>
    );
}